/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateK12ContactRequestJobMutationRequest,
  CreateK12ContactRequestJobMutationResponse,
  CreateK12ContactRequestJob400,
} from '../types/CreateK12ContactRequestJob'

function getCreateK12ContactRequestJobUrl() {
  const res = { method: 'POST', url: `/api/v1/contact_request/k12/` as const }
  return res
}

/**
 * @description Resolve contact-request select-all through the unified opps queryset.
 * Mixed in ahead of ``CreateContactRequestJobView`` + ``UnifiedOppsView`` so the
 * select-all set is re-resolved by the SAME engine that renders the table
 * (unified row ``id`` == chain-proxy id), replacing each vertical's legacy
 * list-view filterset. The vertical is pinned server-side via
 * ``contact_request_target_type`` (the endpoint IS the vertical) rather than
 * trusted from the client, so a missing/wrong client ``target_type`` can never
 * resolve contacts for another vertical. The client still sends the unified
 * filter params (adapted like the list request) so the resolved set matches the
 * rows the user saw.
 * @summary Create a contact request job for K-12 districts
 * {@link /api/v1/contact_request/k12/}
 */
export async function createK12ContactRequestJob(
  data: CreateK12ContactRequestJobMutationRequest,
  config: Partial<RequestConfig<CreateK12ContactRequestJobMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateK12ContactRequestJobMutationResponse,
    ResponseErrorConfig<CreateK12ContactRequestJob400>,
    CreateK12ContactRequestJobMutationRequest
  >({
    method: 'POST',
    url: getCreateK12ContactRequestJobUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
